import { UserActions } from '@next/core-lib/user';
import { createReducer, on } from '@ngrx/store';

import { ProductionState } from '../../models/production.model';
import * as ProductionActions from '../actions/production.actions';

export const initialState: ProductionState = {
  // productionList: null,
  cowList: null,
  productionSummary: null,
};

export const productionReducer = createReducer<ProductionState>(
  initialState,

  on(ProductionActions.loadCowListSuccess, (state, { cowList }) => ({
    ...state,
    cowList,
  })),

  on(ProductionActions.loadProductionSummarySuccess, (state, { productionSummary }) => ({
    ...state,
    productionSummary,
  })),
  on(UserActions.relationshipSelected, () => initialState),
);
